module.exports = __webpack_public_path__ + "static/media/zhengchexiaoshou1.a8b1d049.png";